import React from 'react';
import { aboutText, stats } from '../mock';
import Reveal from './Reveal';

const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-36 bg-[#FAF7F2]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="section-num text-sm">01 &mdash; About</span>
              <h2 className="mt-4 font-serif text-4xl md:text-5xl leading-[1.05] text-[#1a1a1a]">
                A family of stone,
                <br />
                shaped by <span className="italic">passion</span>.
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-6">
            <div className="space-y-6 text-[#4a463f] text-[15.5px] md:text-[17px] leading-[1.85]">
              {aboutText.map((p, i) => (
                <Reveal key={p.slice(0, 40)} delay={i * 100}>
                  <p>{p}</p>
                </Reveal>
              ))}
            </div>

            <Reveal delay={300}>
              <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-[#E5DED0] pt-10">
                {stats.map((s) => (
                  <div key={s.label}>
                    <div className="font-serif text-4xl md:text-5xl text-[#7B1E24]">{s.value}</div>
                    <div className="mt-2 text-[11px] tracking-[0.22em] uppercase text-[#7a7268]">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
